import React from 'react'
import { Link } from 'react-router-dom'
import image from '../../assets/images/Leadership/image10.png'
const COO2 = () => {
  return (
    <div className="container py-lg-5 py-md-4 py-3">
            <div className="row">
                <div className="col-lg-6 col-md-6 d-flex align-items-center">
                    <img className='img-fluid' src={image} alt="Pradip Gaur" />
                </div>
                <div className="col-lg-6 col-md-6 ">
                <div className="ceo">
                    <h6>Leadership</h6>
                    <h1 className='fw-bold mb-3'>Pradip Pandey </h1>
                    <h4>Operations Director (BPO | BPS) | TechTorch Solutions</h4>
                    <div className='social-media'>
                    {/* <Link  className='link'><i className="bi bi-twitter-x"></i></Link> */}
                    <Link to="https://www.linkedin.com/in/pradip-pandey-3a8116154/" className='link'><i className="bi bi-linkedin"></i></Link>
                   
                    </div>
  <p>
    Pradip Pandey brings strategic insight and strong leadership to TechTorch Solutions through his role as Operations Director in the unit of BPO & BPS. With extensive experience in guiding business growth and operational excellence, he plays a vital role in shaping the company’s long-term vision, strengthening internal processes, and supporting key decision-making across the organization.
</p>
<p>
    Pradip works closely with leadership teams to ensure that strategic initiatives are effectively executed and aligned with the company’s goals. His leadership approach is rooted in clarity, collaboration, and accountability, fostering a results-driven culture that encourages innovation, stability, and sustainable growth.
</p>


                </div>
                </div>
            </div>
        </div>
  )
}

export default COO2
